@let count = entries().length;
@let loadingState = loading();
@let onboardingActive = onboardingInProgress();
@let guide = currentGuide();

<div
  class="py-2 px-1.5 bg-white rounded transition-all border-2 border-transparent"
  [class]="
    onboardingActive &&
    count === 0 &&
    (guide === StepGuideId.SaveEmail1 || guide === StepGuideId.EntryActions1)
      ? 'border-pulse-enter'
      : ''
  "
>
  <p class="subtitle-2 py-1 px-1.5">
    {{ 'outlook.main.in-maximizer' | translate: { count: count } }}
  </p>
  @if (loadingState.skeleton || loadingState.syncSubscriptions) {
    @for (item of [0, 1, 2, 3]; track $index) {
      <div class="space-x-2 flex my-2 px-2">
        <maximizer-outlook-skeleton
          containerClasses="h-9 w-9 max-w-9 rounded-full bg-neutral-20"
          fullWidth="none"
        ></maximizer-outlook-skeleton>
        <maximizer-outlook-skeleton
          containerClasses="h-9 w-full rounded-md bg-neutral-20"
        ></maximizer-outlook-skeleton>
      </div>
    }
  } @else {
    <kendo-listview
      [data]="dataResult()"
      (pageChange)="pageChange.emit($event)"
      [pageable]="pagerSettings()"
      [pageSize]="state().take!"
      [skip]="state().skip!"
      class="border-none main-page"
    >
      <ng-template
        kendoListViewItemTemplate
        let-dataItem="dataItem"
        let-index="index"
      >
        <maximizer-outlook-read-entry-row
          [entry]="dataItem"
          [canNavigate]="true"
          [index]="index"
          [onboardingInProgress]="onboardingActive"
          [currentGuide]="guide"
          [currentStep]="currentStep()"
          [entryActionsGuideVisible]="entryActionsGuideVisible()"
          [inMaximizerLength]="count"
          [userRights]="userRights()"
          [userEmails]="userEmails()"
          [autoSaveEnabledIds]="autoSaveEnabledIds()"
          (navigate)="navigateEntry.emit($event)"
          (save)="saveEntry.emit($event)"
        ></maximizer-outlook-read-entry-row>
      </ng-template>
    </kendo-listview>

    @if (count > 1) {
      <div class="flex justify-end pt-1">
        <span
          kendoTooltip
          [tooltipTemplate]="tooltipTemplate"
          position="top"
          [callout]="false"
          [title]="saveAllTooltip()"
        >
          <button
            kendoButton
            id="outlook-main-ui-read-saveAllEntries"
            (click)="saveAll.emit()"
            [class.pointer-events-auto]="
              onboardingActive && currentStep() === OnboardingStepNumber.Step2
            "
            [disabled]="saveAllDisabled()"
            themeColor="primary"
            fillMode="flat"
            class="text-inline-button"
          >
            {{ 'outlook.main.save-to-all' | translate }}
          </button>
        </span>
      </div>
    }
  }
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
